import UpgradeBar from "./UpgradeBar.vue";

export default UpgradeBar;
